<template>
	<div v-if="is_currentDownload">
		<el-dialog :title="downloadTextShow" :visible.sync="dialogDownload" @close="dialogClose">
			<div class="down-shelf-text">
				<div class="down-rogress">{{ fileName_i }} - 当前进度</div>
				<el-progress
					:text-inside="true"
					:stroke-width="24"
					:color="colorStatus[statusLoading]"
					:percentage="pro_percentage"
					status="success"
				></el-progress>
			</div>
		</el-dialog>

		<div
			class="small-skylight"
			v-if="!dialogDownload && is_currentDownload"
			@click="showDialogDownload"
		>
			<el-progress
				:color="colorStatus[statusLoading]"
				type="circle"
				:percentage="pro_percentage"
			></el-progress>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	const CancelToken = axios.CancelToken;
	import JSZip from 'jszip';
	// eslint-disable-next-line no-unused-vars
	import FileSaver from 'file-saver';
	import Vue from "vue";
	export default {
		name: 'operation',
		props: {
			list: {
				type: Array,
			},
			urlName: {
				type: String,
				default: 'url',
			},
			imgName: {
				type: String,
				default: 'name',
			},
			suffixName: {
				type: String,
			},
		},
		data() {
			return {
				fileName_i: '',
				statusLoading: 'down',
				colorStatus: {
					down: '#f56c6c',
					bale: '#e60000',
				},
				// 显示下载 弹窗
				dialogDownload: false,
				// 当前是否有下载
				is_currentDownload: false,
				// 弹窗提示
				downloadTextShow: '正在下载',
				// 当前进度
				pro_percentage: 0,
				cancel: () => {},
				is_clickCancel: false,
			};
		},
		methods: {
			dialogClose() {
				if (this.pro_percentage > 90 && this.pro_percentage < 100) {
					this.$message.error('即将下载完成 请耐心等待');
					return;
				}

				if (this.is_currentDownload) {
					this.$confirm('文件正在下载中！', '提示', {
						confirmButtonText: '等待下载',
						cancelButtonText: '取消下载',
						type: 'warning',
					})
						.then(() => {
							this.dialogDownload = false;
							this.$message.error({
								message: '文件正在下载,请勿关闭当前页面',
								showClose: true,
							});
						})
						.catch(() => {
							this.is_clickCancel = true;
							this.cancel();
							this.statusLoading = 'bale';
							this.dialogDownload = false;
							this.is_currentDownload = false;
						});
				}
			},
			showDialogDownload() {
				this.dialogDownload = true;
			},
			onDownload(zipname, list, urlName, imgName, suffixName) {
				if (this.is_currentDownload) {
					this.$message('当前有文件正在下载...');
					return;
				}
				return this.handleDownload({
					list,
					urlPropertyName: urlName,
					imgNamePropertyName: imgName,
					zipname,
					suffixName,
				});
			},

			onDevAndLine(zipname, list, urlName, fileName, suffixName) {
				if (this.is_currentDownload) {
					this.$message('当前有文件正在下载...');
					return;
				}
				return this.localAndOnlineDownload(
					// 压缩包名字
					zipname,
					// 文件列表
					list,
					// url键 名
					urlName,
					// 文件键名
					fileName,
					//后缀键名
					suffixName
				);
			},

			// 本地与线上文件 合并下载
			localAndOnlineDownload(
				// 压缩包名字
				zipname = 'file',
				// 文件列表
				list,
				// url键 名
				urlName = 'url',
				// 文件键名
				fileName = 'name',
				//后缀键名
				suffixName
			) {
				let local = [];
				let line = [];
				let fileKeyName = 'file';
				const zip = new JSZip();
				if (list.length == 0) {
					return Promise.reject;
				}
				return new Promise(async (resolve, reject) => {
					list.forEach((item) => {
						let fileKeys = Object.keys(item).filter((file) => {
							return item[file] instanceof File;
						});
						if (fileKeys.length > 0) {
							fileKeyName = fileKeys[0];
							// 本地文件
							local.push(item);
							const file_name = `${item[fileName]}${
								suffixName && item[suffixName] ? item[suffixName] : ''
							}`;

							zip.file(file_name, item[fileKeyName], { binary: true });
						} else {
							// 线上文件
							line.push(item);
						}
					});

					// 只有本地文件
					if (line.length == 0 && local.length > 0) {
						zip.generateAsync({ type: 'blob' }).then((content) => {
							// 生成二进制流
							// FileSaver.saveAs(content, '文件下载.zip') // 利用file-saver保存文件  自定义文件名
							// eslint-disable-next-line no-undef
							this.downloadTextShow = `正在生成-${zipname}.zip`;
							this.is_currentDownload = false;
							FileSaver.saveAs(content, `${zipname}.zip`); // 利用file-saver保存文件  自定义文件名
							this.dialogDownload = false;

							setTimeout(() => {
								this.statusLoading = 'down';
								// 弹窗提示
								this.downloadTextShow = '正在下载';
								// 当前进度
								this.pro_percentage = 0;
								resolve();
							}, 200);
						});
						return;
					}

					// 下载线上文件
					let { size: totalSize } = line.reduce((total, item) => {
						return { size: Number(total.size) + Number(item.size) };
					});

					const total = line.length;
					if (totalSize < 1024 ** 3) {
						this.dialogDownload = true;
						this.is_currentDownload = true;
						this.is_clickCancel = false;
						this.downloadTextShow = `正在下载-${zipname}`;

						for (let i = 0; i < total; i++) {
							let item = line[i];
							///////////////////
							// 点击了取消下载
							if (this.is_clickCancel) {
								reject();
								return false;
							}

							// 当前下载名称
							// if (totalSize > 1024 ** 2 * 250) {
							//   window.open(this.$route.fullPath, "_blank"); // 跳转到新页面
							// }
							this.fileName_i = item[fileName];
							const promise = await this.getFile(
								item[urlName],
								(ing) => {
									let complete = parseInt((ing.loaded / ing.total) * 100);
									this.pro_percentage = complete;
								},
								(c) => {
									this.cancel = c;
								},
								() => {
									if (!this.is_clickCancel) {
										this.$message(`${this.fileName_i}此文件需要单独下载，是否单独下载？`);
									}
								}
							);
							const file_name = `${item[fileName]}${
								suffixName && item[suffixName] ? item[suffixName] : ''
							}`;
							zip.file(file_name, promise, { binary: true });
						}

						this.statusLoading = 'bale';
						this.downloadTextShow = `正在打包-${zipname}`;
						zip.generateAsync({ type: 'blob' }).then((content) => {
							// 生成二进制流
							// FileSaver.saveAs(content, '文件下载.zip') // 利用file-saver保存文件  自定义文件名
							// eslint-disable-next-line no-undef
							this.downloadTextShow = `正在生成-${zipname}.zip`;
							this.is_currentDownload = false;
							FileSaver.saveAs(content, `${zipname}.zip`); // 利用file-saver保存文件  自定义文件名
							this.dialogDownload = false;

							setTimeout(() => {
								this.statusLoading = 'down';
								// 弹窗提示
								this.downloadTextShow = '正在下载';
								// 当前进度
								this.pro_percentage = 0;
								resolve();
							}, 200);
						});
					} else {
						this.$message({
							message: `当前${zipname}打包文件大小超过1G，为了更好下载文件，请点击“下载”按钮单独下载每个文件！`,
							showClose: true,
						});
						resolve({ msg: 'big' });
					}
				});
			},
			/**
			 * 下载按钮点击事件
			 * list 文件列表
			 * urlPropertyName子项文件 链接 键名
			 * imgNamePropertyName 子项文件 名
			 * @param {Object} param0
			 */
			handleDownload({
				list,
				urlPropertyName = 'url',
				imgNamePropertyName = '',
				zipname,
				suffixName,
			}) {
				list = list.filter((item) => {
					return item[urlPropertyName];
				});

				if (list.length == 0) {
					return Promise.reject;
				}
				console.log(location);

				return new Promise(async (resolve, reject) => {
					try {
						let { size: totalSize } = list.reduce((total, item) => {
							return { size: Number(total.size) + Number(item.size) };
						});
						if (totalSize < 1024 ** 3) {
							this.dialogDownload = true;
							this.is_currentDownload = true;
							this.is_clickCancel = false;
							const zip = new JSZip();
							const cache = {};
							const promises = [];
							const total = list.length;
							this.downloadTextShow = `正在下载-${zipname}`;
							for (let i = 0; i < total; i++) {
								let item = list[i];
								///////////////////

								// 点击了取消下载
								if (this.is_clickCancel) {
									reject();
									return false;
								}

								// 当前下载名称
								// if (totalSize > 1024 ** 2 * 250) {
								// 	window.open(this.$route.fullPath, '_blank'); // 跳转到新页面
								// }
								this.fileName_i = item[imgNamePropertyName];
								const promise = await this.getFile(
									item[urlPropertyName],
									(ing) => {
										let complete = parseInt((ing.loaded / ing.total) * 100);
										this.pro_percentage = complete;
									},
									(c) => {
										this.cancel = c;
									},
									() => {
										if (!this.is_clickCancel) {
											this.$message(`${this.fileName_i}此文件需要单独下载，是否单独下载？`);
										}
									}
								);
								const file_name = `${item[imgNamePropertyName]}${
									suffixName && item[suffixName] ? item[suffixName] : ''
								}`;
								if (total == 1) {
									FileSaver.saveAs(promise, `${zipname}-${file_name}`); // 保存文件
									this.statusLoading = 'bale';
									this.dialogDownload = false;
									this.is_currentDownload = false;
									resolve();
								} else {
									zip.file(file_name, promise, { binary: true });
								}
							}

							if (total > 1) {
								this.statusLoading = 'bale';
								this.downloadTextShow = `正在打包-${zipname}`;
								zip.generateAsync({ type: 'blob' }).then((content) => {
									// 生成二进制流
									// FileSaver.saveAs(content, '文件下载.zip') // 利用file-saver保存文件  自定义文件名
									// eslint-disable-next-line no-undef
									this.downloadTextShow = `正在生成-${zipname}.zip`;
									this.is_currentDownload = false;
									FileSaver.saveAs(content, `${zipname}.zip`); // 利用file-saver保存文件  自定义文件名
									this.dialogDownload = false;

									setTimeout(() => {
										this.statusLoading = 'down';
										// 弹窗提示
										this.downloadTextShow = '正在下载';
										// 当前进度
										this.pro_percentage = 0;
										resolve();
									}, 200);
								});
							}
						} else {
							this.$message({
								message: `当前${zipname}打包文件大小超过1G，为了更好下载文件，请点击“下载”按钮单独下载每个文件！`,
								showClose: true,
							});
							resolve({ msg: 'big' });
						}
					} catch (error) {
						console.log(error);
						reject(error);
					}

					//////////////////////////////////
				});
			},
			/**
			 * 获取文件
			 * @param url 文件路径
			 * @returns {Promise<unknown>}
			 */
			getFile(url, loading, cancel, errFn = () => {}) {
				return new Promise((resolve, reject) => {
					axios({
						method: 'get',
						url,
						responseType: 'blob',
						cancelToken: new CancelToken(cancel),
						// responseType: 'arraybuffer'
						onDownloadProgress: (progressEvent) => {
							if (loading) {
								loading(progressEvent);
							}
						},
					})
						.then((data) => {
							resolve(data.data);
						})
						.catch((error) => {
							errFn();
							reject(error.toString());
						});
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.small-skylight {
		position: fixed;
		top: 70px;
		right: 160px;
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 6px;
		width: 70px;
		height: 70px;
		border-radius: 50%;
		background-color: #fff;
		box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.4);

		animation-name: tilt-in-bl;
		animation-duration: 1s;
		animation-timing-function: ease;
		animation-delay: 0s;
		animation-iteration-count: 1;
		animation-direction: normal;
		animation-fill-mode: none;
	}

	@keyframes tilt-in-bl {
		0% {
			transform: rotateY(35deg) rotateX(-20deg) translate(-250px, 250px) skew(-12deg, -15deg);
			opacity: 0;
		}
		100% {
			transform: rotateY(0) rotateX(0deg) translate(0, 0) skew(0deg, 0deg);
			opacity: 1;
		}
	}
</style>
